import { FC, PropsWithChildren, ReactNode, useEffect, useState } from 'react';
import { css } from '@emotion/css';
import { theme } from 'antd';

// May-12-2025: used Gemini 2.5 to refactor RadioList (and related css) to not use Antd components

/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

const listGroupStyle = css`
  border-width: 1px;
  border-style: solid;
  border-radius: 6px;
  width: 100%;
`;

const listItemStyle = css`
  display: block;
  position: relative;
  border-bottom: 1px solid;
  border-left: 3px solid;
  cursor: pointer;
  padding-left: 9px;
  &:hover {
    background-color: #f0f2f5;
    border-left: 3px solid rgba(0, 0, 0, 0);
  }
  user-select: none;
`;

const selectedItemStyle = css`
  border-left: 3px solid;
  padding-left: 9px;
`;

export const RadioList: FC<{
  items: ReactNode[];
  curSelectionIdx?: number;
  onChange: (idx: number) => void;
}> = ({ items, onChange, curSelectionIdx: defaultSelectedIdx = -1 }) => {
  const {
    token: { colorInfo, colorInfoBg, colorBgContainer, colorText, colorBorder },
  } = theme.useToken();
  const [selectedIdx, setSelectedIdx] = useState<number>(defaultSelectedIdx);

  useEffect(() => {
    setSelectedIdx(defaultSelectedIdx);
  }, [defaultSelectedIdx]);

  return (
    <div
      className={listGroupStyle}
      style={{ borderColor: colorBorder, color: colorText }}
    >
      {items.map((item, idx) => (
        <div
          key={'radio-item-' + idx}
          className={css`
            ${listItemStyle} ${selectedIdx === idx ? selectedItemStyle : ''}
          `}
          style={{
            borderLeftColor: selectedIdx === idx ? colorInfo : colorBorder,
            borderBottomColor: colorBorder,
            backgroundColor:
              selectedIdx === idx ? colorInfoBg : colorBgContainer,
          }}
          onClick={() => {
            setSelectedIdx(idx);
            onChange(idx);
          }}
        >
          {item}
        </div>
      ))}
    </div>
  );
};

export const RadioListItem: FC<PropsWithChildren<{ padding?: number }>> = ({
  children,
  padding = 12,
}) => {
  return (
    <div
      style={{
        paddingTop: padding,
        paddingBottom: padding,
        paddingLeft: 4,
        paddingRight: 4,
      }}
    >
      {children}
    </div>
  );
};
